var render = function render(){var _vm=this,_c=_vm._self._c;return _c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.val),expression:"val"}],ref:"textarea",staticClass:"rounded-lg",class:[
		_vm.markInvalid
			? 'text-red-500 border-red-500 shadow-sm focus:text-gray-900'
			: '',
	],attrs:{"rows":_vm.rows},domProps:{"value":(_vm.val)},on:{"input":[function($event){if($event.target.composing)return;_vm.val=$event.target.value},_vm.resize]}})
}
var staticRenderFns = []

export { render, staticRenderFns }